import Base from "./base";

export default class TurboHavale extends Base {
    makeExternalPayment(newStep) {
        const {  stake } = this.state;
        this.props.externalFunc.makeDeposit({
            processType: "havale",
            paymentType: "havale",
            returnUrl: location.href,
            amount: stake
        }, (data) => {
            this.setState({
                externalUrl: data.url,
                currentStep: newStep
            })
        });
    }

    makeExternalPaymentWithBonus(newStep, bonusId) {
        const { iban, stake } = this.state;
        this.props.externalFunc.makeDeposit({
            processType: "havale",
            paymentType: "havale",
            returnUrl: location.href,
            amount: stake,
            claimsBonus: true,
            bonusId: bonusId
        }, (data) => {
            this.setState({
                externalUrl: data.url,
                currentStep: newStep
            })
        });
    }
}
